import React from 'react'
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material'

type SignupStep2FormProps = {
  formValues: any
  errors: any
  handleInputChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleBlur: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  handleSelectChange: (e: any) => void
  handleServicesChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBack: () => void
  handleSubmit: (e: React.FormEvent) => void
  t: (key: string) => string
}

const SignUpStep2Form: React.FC<SignupStep2FormProps> = ({
  formValues,
  errors,
  handleInputChange,
  handleBlur,
  handleSelectChange,
  handleServicesChange,
  handleBack,
  handleSubmit,
  t
}) => {
  return (
    <Box>
      <TextField
        label={t('signup.currentSupplier')}
        name='currentSupplier'
        value={formValues.currentSupplier}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={t('signup.required')}
        fullWidth
        variant='outlined'
        required
        margin='dense'
        error={errors.currentSupplier}
        helperText={
          errors.currentSupplier ? t('signup.currentSupplierRequired') : ''
        }
        inputProps={{ maxLength: 50 }}
      />

      <TextField
        label={t('signup.averagePurchase')}
        name='averagePurchase'
        value={formValues.averagePurchase}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={t('signup.required')}
        fullWidth
        variant='outlined'
        required
        margin='dense'
        error={errors.averagePurchase}
        helperText={
          errors.averagePurchase ? t('signup.averagePurchaseRequired') : ''
        }
      />

      <FormControl
        component='fieldset'
        fullWidth
        margin='dense'
        required
        error={errors.services}
      >
        <Typography variant='h4' gutterBottom>
          {t('signup.servicesTitle')}
        </Typography>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={formValues.services.includes('Design Services')}
                onChange={handleServicesChange}
                name='Design Services'
              />
            }
            label={t('signup.designServices')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formValues.services.includes(
                  'Cabinets only (you provide material list)'
                )}
                onChange={handleServicesChange}
                name='Cabinets only (you provide material list)'
              />
            }
            label={t('signup.cabinetsOnly')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formValues.services.includes(
                  'Installation Services (Atlanta office only)'
                )}
                onChange={handleServicesChange}
                name='Installation Services (Atlanta office only)'
              />
            }
            label={t('signup.installationServices')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={formValues.services.includes(
                  'Online ordering (dealers only)'
                )}
                onChange={handleServicesChange}
                name='Online ordering (dealers only)'
              />
            }
            label={t('signup.onlineOrdering')}
          />
        </FormGroup>
        {errors.services && (
          <Typography
            variant='caption'
            sx={{
              mt: '3px'
            }}
          >
            {t('signup.servicesRequired')}
          </Typography>
        )}
      </FormControl>

      <FormControl fullWidth margin='dense' required error={errors.source}>
        <InputLabel>{t('signup.sourceLabel')}</InputLabel>
        <Select
          label={t('signup.sourceLabel')}
          name='source'
          value={formValues.source}
          onChange={handleSelectChange}
          onBlur={handleBlur}
        >
          <MenuItem value='Search engine'>{t('signup.searchEngine')}</MenuItem>
          <MenuItem value='Social media'>{t('signup.socialMedia')}</MenuItem>
          <MenuItem value='Referral from another customer'>
            {t('signup.referral')}
          </MenuItem>
          <MenuItem value='Trade show'>{t('signup.tradeShow')}</MenuItem>
          <MenuItem value='Direct email or phone call from Muses Cabinets'>
            {t('signup.directContact')}
          </MenuItem>
          <MenuItem value='Other'>{t('signup.other')}</MenuItem>
        </Select>
        {errors.source && (
          <Typography
            variant='caption'
            sx={{
              mt: '3px'
            }}
            color='error'
          >
            {t('signup.sourceRequired')}
          </Typography>
        )}
      </FormControl>

      <FormControl
        fullWidth
        margin='dense'
        required
        error={errors.businessType}
      >
        <InputLabel>{t('signup.businessTypeLabel')}</InputLabel>
        <Select
          label={t('signup.businessTypeLabel')}
          name='businessType'
          value={formValues.businessType}
          onChange={handleSelectChange}
          onBlur={handleBlur}
        >
          <MenuItem value='Builder/general contractor'>
            {t('signup.builder')}
          </MenuItem>
          <MenuItem value='Remodeler'>{t('signup.remodeler')}</MenuItem>
          <MenuItem value='Designer'>{t('signup.designer')}</MenuItem>
          <MenuItem value='Dealer'>{t('signup.dealer')}</MenuItem>
          <MenuItem value='Homeowner'>{t('signup.homeowner')}</MenuItem>
          <MenuItem value='Other'>{t('signup.other')}</MenuItem>
        </Select>
        {errors.businessType && (
          <Typography
            variant='caption'
            sx={{
              mt: '3px'
            }}
            color='error'
          >
            {t('signup.businessTypeRequired')}
          </Typography>
        )}
      </FormControl>

      <Box display='flex' justifyContent='space-between' marginTop={4}>
        <Button
          variant='outlined'
          sx={{
            width: '48%'
          }}
          onClick={handleBack}
        >
          {t('signup.backButton')}
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleSubmit}
          sx={{ width: '48%' }}
        >
          {t('signup.submitButton')}
        </Button>
      </Box>
    </Box>
  )
}

export default SignUpStep2Form
